// // src/components/Testimonials.jsx

// import React, { useState } from 'react';
// import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';

// const Testimonials = ({ language, content }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const t = content[language].testimonials;

//   const nextTestimonial = () => {
//     setCurrentIndex((prev) => (prev + 1) % t.testimonials.length);
//   };

//   const prevTestimonial = () => {
//     setCurrentIndex((prev) => (prev - 1 + t.testimonials.length) % t.testimonials.length);
//   };

//   const currentTestimonial = t.testimonials[currentIndex];

//   return (
//     <>
//       <style>{`
//         .testimonials-section {
//           padding: 100px 0;
//           background: #f8f9fa;
//           position: relative;
//         }

//         .testimonials-container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 20px;
//         }

//         .testimonials-header {
//           text-align: center;
//           margin-bottom: 60px;
//         }

//         .testimonials-header h3 {
//           font-size: 40px;
//           color: #1a1a1a;
//           margin-bottom: 16px;
//         }

//         .testimonials-header p {
//           font-size: 18px;
//           color: #666;
//         }

//         .testimonials-slider {
//           position: relative;
//           max-width: 900px;
//           margin: 0 auto;
//         }

//         .testimonial-card {
//           background: white;
//           padding: 56px;
//           border-radius: 24px;
//           box-shadow: 0 12px 48px rgba(0, 0, 0, 0.12);
//           position: relative;
//           animation: fadeInScale 0.5s ease;
//           border: 3px solid #fff5f2;
//         }

//         @keyframes fadeInScale {
//           from {
//             opacity: 0;
//             transform: scale(0.95);
//           }
//           to {
//             opacity: 1;
//             transform: scale(1);
//           }
//         }

//         .quote-icon {
//           position: absolute;
//           top: 24px;
//           left: 24px;
//           color: #ff6b35;
//           opacity: 0.2;
//         }

//         .rating {
//           display: flex;
//           gap: 4px;
//           margin-bottom: 20px;
//           justify-content: center;
//         }

//         .testimonial-text {
//           font-size: 18px;
//           line-height: 1.8;
//           color: #333;
//           margin-bottom: 32px;
//           text-align: center;
//           font-style: italic;
//         }

//         .testimonial-author {
//           text-align: center;
//         }

//         .author-name {
//           font-size: 20px;
//           font-weight: 600;
//           color: #1a1a1a;
//           margin-bottom: 4px;
//         }

//         .author-service {
//           font-size: 15px;
//           color: #ff6b35;
//           font-weight: 500;
//           margin-bottom: 4px;
//         }

//         .author-location {
//           font-size: 14px;
//           color: #999;
//         }

//         .slider-controls {
//           display: flex;
//           justify-content: center;
//           gap: 16px;
//           margin-top: 32px;
//         }

//         .slider-button {
//           width: 56px;
//           height: 56px;
//           border-radius: 50%;
//           border: 3px solid #ff6b35;
//           background: white;
//           color: #ff6b35;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           transition: all 0.3s;
//           box-shadow: 0 4px 16px rgba(255, 107, 53, 0.2);
//         }

//         .slider-button:hover {
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           color: white;
//           transform: scale(1.1);
//           box-shadow: 0 6px 24px rgba(255, 107, 53, 0.4);
//         }

//         .slider-dots {
//           display: flex;
//           justify-content: center;
//           gap: 8px;
//           margin-top: 24px;
//         }

//         .dot {
//           width: 10px;
//           height: 10px;
//           border-radius: 50%;
//           background: #ddd;
//           cursor: pointer;
//           transition: all 0.3s;
//         }

//         .dot.active {
//           background: #ff6b35;
//           width: 32px;
//           border-radius: 5px;
//         }

//         @media (max-width: 768px) {
//           .testimonials-section {
//             padding: 60px 0;
//           }

//           .testimonials-header h3 {
//             font-size: 28px;
//           }

//           .testimonial-card {
//             padding: 32px 24px;
//           }

//           .testimonial-text {
//             font-size: 16px;
//           }

//           .quote-icon {
//             display: none;
//           }
//         }
//       `}</style>

//       <section className="testimonials-section">
//         <div className="testimonials-container">
//           <div className="testimonials-header">
//             <h3>{t.title}</h3>
//             <p>{t.subtitle}</p>
//           </div>

//           <div className="testimonials-slider">
//             <div className="testimonial-card">
//               <Quote size={48} className="quote-icon" />
              
//               <div className="rating">
//                 {[...Array(currentTestimonial.rating)].map((_, i) => (
//                   <Star key={i} size={20} fill="#FFB800" color="#FFB800" />
//                 ))}
//               </div>

//               <p className="testimonial-text">"{currentTestimonial.text}"</p>

//               <div className="testimonial-author">
//                 <div className="author-name">{currentTestimonial.name}</div>
//                 <div className="author-service">{currentTestimonial.service}</div>
//                 <div className="author-location">{currentTestimonial.location}</div>
//               </div>
//             </div>

//             <div className="slider-controls">
//               <button className="slider-button" onClick={prevTestimonial}>
//                 <ChevronLeft size={24} />
//               </button>
//               <button className="slider-button" onClick={nextTestimonial}>
//                 <ChevronRight size={24} />
//               </button>
//             </div>

//             <div className="slider-dots">
//               {t.testimonials.map((_, index) => (
//                 <div
//                   key={index}
//                   className={`dot ${index === currentIndex ? 'active' : ''}`}
//                   onClick={() => setCurrentIndex(index)}
//                 />
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Testimonials;

import React, { useState } from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials = ({ language, content }) => {
  const [isPaused, setIsPaused] = useState(false);
  const t = content[language].testimonials;

  // Duplicate testimonials for seamless infinite scroll
  const duplicatedTestimonials = [...t.testimonials, ...t.testimonials, ...t.testimonials];

  return (
    <>
      <style>{`
        .testimonials-section {
          padding: 60px 0;
          background: #f8f9fa;
          position: relative;
          overflow: hidden;
        }

        .testimonials-container {
          max-width: 100%;
          margin: 0 auto;
          padding: 0 20px;
        }

        .testimonials-header {
          text-align: center;
          margin-bottom: 35px;
        }

        .testimonials-header h2 {
             font-size: 40px;
    color: #1a1a1a;
    margin-bottom: 16px;
    font-weight: 700;
    background: linear-gradient(135deg, #1a1a1a 0%, #ff6b35 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
        }

        .testimonials-header p {
          font-size: 18px;
          color: #666;
        }

        .testimonials-track-wrapper {
          overflow: hidden;
          position: relative;
          width: 100%;
        }

        .testimonials-track-wrapper::before,
        .testimonials-track-wrapper::after {
          content: '';
          position: absolute;
          top: 0;
          width: 100px;
          height: 100%;
          z-index: 2;
        }

        .testimonials-track-wrapper::before {
          left: 0;
          background: linear-gradient(to right, #f8f9fa, transparent);
        }

        .testimonials-track-wrapper::after {
          right: 0;
          background: linear-gradient(to left, #f8f9fa, transparent);
        }

        .testimonials-track {
          display: flex;
          gap: 24px;
          animation: scroll 40s linear infinite;
          width: fit-content;
          margin:25px 0;
        }

        .testimonials-track.paused {
          animation-play-state: paused;
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        .testimonial-card {
          background: white;
          padding: 25px;
          border-radius: 20px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          min-width: 400px;
          max-width: 400px;
          position: relative;
          border: 2px solid #fff5f2;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          flex-shrink: 0;
        }

        .testimonial-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
        }

        .quote-icon {
          position: absolute;
          top: 20px;
          left: 20px;
          color: #ff6b35;
          opacity: 0.15;
          width:40px;
        }

        .rating {
          display: flex;
          gap: 4px;
          margin-bottom: 16px;
          position: relative;
          z-index: 1;
        }

        .testimonial-text {
          font-size: 16px;
          line-height: 1.7;
          color: #333;
          margin-bottom: 10px;
          font-style: italic;
          position: relative;
          z-index: 1;
          min-height: 100px;
        }

        .testimonial-author {
          border-top: 2px solid #f5f5f5;
          padding-top: 10px;
        }

        .author-name {
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 4px;
        }

        .author-service {
          font-size: 14px;
          color: #ff6b35;
          font-weight: 500;
          margin-bottom: 4px;
        }

        .author-location {
          font-size: 13px;
          color: #999;
        }

        @media (max-width: 768px) {
          .testimonials-section {
            padding: 60px 0;
          }

          .testimonials-header h2 {
            font-size: 28px;
          }

          .testimonial-card {
            min-width: 300px;
            max-width: 300px;
            padding: 22px;
          }

          .testimonial-text {
            font-size: 15px;
            min-height: 80px;
          }

          .testimonials-track {
            animation-duration: 30s;
          }

          .quote-icon {
            display: none;
          }
        }
      `}</style>

      <section className="testimonials-section">
        <div className="testimonials-container">
          <div className="testimonials-header">
            <h2>{t.title}</h2>
            <p>{t.subtitle}</p>
          </div>

          <div className="testimonials-track-wrapper">
            <div 
              className={`testimonials-track ${isPaused ? 'paused' : ''}`}
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              {duplicatedTestimonials.map((testimonial, index) => (
                <div key={index} className="testimonial-card">
                  <Quote size={56} className="quote-icon" />
                  
                  <div className="rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} size={18} fill="#FFB800" color="#FFB800" />
                    ))}
                  </div>

                  <p className="testimonial-text">"{testimonial.text}"</p>

                  <div className="testimonial-author">
                    <div className="author-name">{testimonial.name}</div>
                    <div className="author-service">{testimonial.service}</div>
                    <div className="author-location">{testimonial.location}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonials;